/* Catherine Gee — Parisian Noir behaviour layer. Prestige's own JS (drawers, cart, popups, facets) stays untouched;
   this only adds reveal-on-scroll, hero still swapping, menu child marking, PLP season ordering, stockist search. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  const init = (root = document) => {
    // Reveal once.
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((es) => { es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } }); }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
      $$(".cg-reveal:not(.is-in)", root).forEach((el) => io.observe(el));
    } else { $$(".cg-reveal", root).forEach((el) => el.classList.add("is-in")); }

    // Hero stills: hard swap every N ms, no transition (Kevin 10/17).
    $$("[data-cg-slides]:not([data-bound])", root).forEach((box) => {
      box.dataset.bound = "1";
      const imgs = $$("img", box); if (imgs.length < 2 || reduce) return;
      let i = 0;
      let every = +box.dataset.interval || 3000;
      if (every < 100) every *= 1000;            // a value in seconds (section setting) becomes milliseconds
      every = Math.max(every, 1500);
      setInterval(() => { imgs[i].classList.remove("is-on"); i = (i + 1) % imgs.length; imgs[i].classList.add("is-on"); }, every);
    });

    // Wishlist (Swym): a heart in the header next to search; Swym opens its wishlist for any #swym-wishlist link.
    const sec = $(".header__secondary-nav ul", root);
    if (sec && !$(".cg-wishlist-link", sec)) {
      const li = document.createElement("li"); li.className = "cg-wishlist-link";
      li.innerHTML = '<a href="#swym-wishlist" aria-label="Wishlist"><svg class="header__nav-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.4-9.1C1.4 8.4 3.3 4.5 7 4.5c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.7 0 5.6 3.9 4.4 6.9-1.9 4.5-9.4 9.1-9.4 9.1z"/></svg></a>';
      const search = $(".header__search-link", sec); sec.insertBefore(li, search || sec.lastElementChild);
      li.querySelector("a").addEventListener("click", (e) => {
        e.preventDefault();
        try { if (window._swat && window._swat.ui && window._swat.ui.open) window._swat.ui.open(); else location.hash = "swym-wishlist"; } catch (err) {}
      });
    }

    // Mega menu: chapter links ("Ch. 1 · …") read as children of their season.
    $$(".mega-menu__linklist a", root).forEach((a) => { if (/^Ch\.\s*\d/.test(a.textContent.trim())) a.classList.add("is-child"); });

    // Prestige product cards elsewhere (related products): split "Family - Colourway" on two lines.
    $$(".product-card .product-title:not([data-split])", root).forEach((t) => {
      t.dataset.split = "1";
      const m = t.textContent.trim().match(/^(.*?)\s+[-–—|]\s+(.*)$/);
      if (m) t.innerHTML = `${m[1]}<small>${m[2]}</small>`;
    });

    // PDP: the H1 keeps the style name; the colourway already sits in the Print / Colour label.
    $$(".product-info h1:not([data-split]), .product-info .product-info__title:not([data-split])", root).forEach((t) => {
      t.dataset.split = "1";
      const m = t.textContent.trim().match(/^(.*?)\s+[-–—|]\s+(.*)$/);
      if (m) t.textContent = m[1];
    });

    // PLP: this season's pieces first, keeping the collection's own order inside each group. Only for "best selling"
    // and manual orders; a newest-first collection (Leopard) or a shopper-chosen sort (price, date) is left as sorted.
    $$(".cg-plp-grid:not([data-ordered])", root).forEach((grid) => {
      grid.dataset.ordered = "1";
      if (grid.dataset.sort && !/^(best-selling|manual)$/.test(grid.dataset.sort)) return;
      const cards = $$(":scope > .cg-card", grid);
      if (!cards.some((c) => c.dataset.season === "current")) return;
      const now = cards.filter((c) => c.dataset.season === "current"), rest = cards.filter((c) => c.dataset.season !== "current");
      now.concat(rest).forEach((c) => grid.appendChild(c));
    });

    // Phones: long product grids show eight, then "Show all".
    $$("[data-cg-more-btn]:not([data-bound])", root).forEach((b) => {
      b.dataset.bound = "1";
      b.addEventListener("click", () => { const g = b.closest(".cg-more").previousElementSibling; if (g) { g.classList.add("is-open"); $$(".cg-reveal", g).forEach((el) => el.classList.add("is-in")); } b.closest(".cg-more").remove(); });
    });

    // Horizontal rails (phones): arrows + a progress line under every scrolling row; the first tile keeps the gutter.
    const chev = (d) => `<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="${d === "l" ? "M10 2 4 8l6 6" : "M6 2l6 6-6 6"}"/></svg>`;
    $$(".cg-scroll:not([data-rail])", root).forEach((sc) => {
      sc.dataset.rail = "1";
      const nav = document.createElement("div"); nav.className = "cg-rail__nav"; nav.hidden = true;
      nav.innerHTML = `<button type="button" class="cg-rail__btn" data-prev aria-label="Previous">${chev("l")}</button><div class="cg-rail__bar"><i></i></div><button type="button" class="cg-rail__btn" data-next aria-label="Next">${chev("r")}</button>`;
      sc.after(nav);
      const prev = nav.querySelector("[data-prev]"), next = nav.querySelector("[data-next]"), bar = nav.querySelector("i");
      const step = () => { const c = sc.firstElementChild; const gap = parseFloat(getComputedStyle(sc).columnGap) || 10; return c ? c.getBoundingClientRect().width + gap : sc.clientWidth * 0.8; };
      const update = () => {
        const max = sc.scrollWidth - sc.clientWidth;
        nav.hidden = max < 8;
        if (nav.hidden) return;
        prev.disabled = sc.scrollLeft < 4; next.disabled = sc.scrollLeft > max - 4;
        const frac = Math.max(sc.clientWidth / sc.scrollWidth, 0.12);
        bar.style.width = frac * 100 + "%";
        bar.style.transform = `translateX(${(sc.scrollLeft / sc.scrollWidth) * 100 / frac}%)`;
      };
      prev.addEventListener("click", () => sc.scrollBy({ left: -step(), behavior: "smooth" }));
      next.addEventListener("click", () => sc.scrollBy({ left: step(), behavior: "smooth" }));
      sc.addEventListener("scroll", update, { passive: true }); addEventListener("resize", update);
      update(); setTimeout(update, 600);
    });

    // Print tiles above a collection grid (Animal Print): count each print's pieces, hide empty tiles, filter in place.
    const ptiles = $("[data-cg-print-tiles]");
    const pgrid = $(".cg-plp-grid");
    if (ptiles && pgrid) {
      const tiles = $$("[data-cg-print-tile]", ptiles), all = $("[data-cg-print-all]", ptiles);
      const cards = () => $$(":scope > .cg-card", pgrid);
      const countEl = $(".cg-toolbar .cg-num");
      const apply = (h, scroll) => {
        window.__cgPrint = h || "";
        let shown = 0;
        cards().forEach((c) => { const on = !h || c.dataset.print === h; c.classList.toggle("is-filtered-out", !on); if (on) { shown++; c.classList.add("is-in"); } });
        tiles.forEach((t) => t.classList.toggle("is-on", t.dataset.cgPrintTile === h));
        ptiles.classList.toggle("has-active", !!h);
        if (all) all.hidden = !h;
        pgrid.dataset.cgPrintApplied = h || "";
        const bar = $(".cg-toolbar .cg-toolbar__group"), oldChip = $("[data-cg-print-chip]");
        if (oldChip) oldChip.remove();
        if (bar && h) {
          const tile = tiles.find((x) => x.dataset.cgPrintTile === h), name = tile ? ($(".cg-ptile__name", tile) || {}).textContent : h;
          const chip = document.createElement("button"); chip.type = "button"; chip.className = "cg-pill is-on cg-print-chip"; chip.dataset.cgPrintChip = h;
          chip.setAttribute("aria-label", `Showing ${name}. Show all prints`);
          chip.innerHTML = `${name}<span aria-hidden="true" class="cg-print-chip__x">×</span>`;
          chip.addEventListener("click", () => apply("", false));
          bar.appendChild(chip);
        }
        if (countEl && countEl.textContent !== String(shown)) countEl.textContent = shown;   // only on change: the PLP observer watches text
        const u = new URL(location.href); h ? u.searchParams.set("print", h) : u.searchParams.delete("print"); history.replaceState(null, "", u);
        if (scroll) { const top = pgrid.getBoundingClientRect().top + scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--sticky-area-height")) || 80) - 90; if (Math.abs(scrollY - top) > 40) scrollTo({ top, behavior: "smooth" }); }
      };
      if (!ptiles.dataset.bound) {
        ptiles.dataset.bound = "1";
        const n = {}; cards().forEach((c) => { if (c.dataset.print) n[c.dataset.print] = (n[c.dataset.print] || 0) + 1; });
        tiles.forEach((t) => {
          const k = n[t.dataset.cgPrintTile] || 0; const el = $("[data-cg-print-count]", t);
          if (el) el.textContent = k ? `${k} ${k === 1 ? "piece" : "pieces"}` : "";
          if (!k) t.hidden = true;
          t.addEventListener("click", (e) => { e.preventDefault(); apply(window.__cgPrint === t.dataset.cgPrintTile ? "" : t.dataset.cgPrintTile, true); });
        });
        if (all) all.addEventListener("click", (e) => { e.preventDefault(); apply("", true); });
        apply(new URLSearchParams(location.search).get("print") || "", false);
      } else if ((pgrid.dataset.cgPrintApplied || "") !== (window.__cgPrint || "")) {
        apply(window.__cgPrint, false);   // a fresh grid (sort or filters re-rendered it): keep the chosen print
      }
    }

    // Print page hero: the swatch square is exactly as tall as the text block.
    $$(".cg-print-hero", root).forEach((ph) => {
      const fit = () => { const t = $(".cg-print-hero__text", ph); if (t) ph.style.setProperty("--swatch-h", Math.round(t.getBoundingClientRect().height) + "px"); };
      fit(); addEventListener("resize", fit); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    });

    // Stockists: group the page body (state headings in <b>, one boutique per line) and search it.
    const stock = $("[data-cg-stock]:not([data-built])", root);
    if (stock) {
      stock.dataset.built = "1";
      const raw = $("[data-cg-stock-source]", stock);
      if (raw) {
        const groups = []; let cur = null;
        raw.querySelectorAll("div, p").forEach((el) => {
          if (el.querySelector("div, p")) return;
          const bold = el.querySelector("b, strong");
          const text = el.textContent.replace(/\s+/g, " ").trim();
          if (!text) return;
          if (bold && bold.textContent.trim().length > 1 && text === bold.textContent.replace(/\s+/g, " ").trim()) { cur = { name: text, items: [] }; groups.push(cur); return; }
          if (cur) cur.items.push(text);
        });
        if (groups.length) {
          const phone = matchMedia("(max-width: 720px)").matches;
          const html = groups.map((g) => `<details${phone ? "" : " open"}><summary><span>${g.name}</span><span class="cg-stock__n">${g.items.length}</span></summary><ul class="cg-ul">${g.items.map((i) => `<li>${i}</li>`).join("")}</ul></details>`).join("");
          const out = document.createElement("div"); out.className = "cg-stock"; out.innerHTML = html; raw.replaceWith(out);
          const count = $("[data-cg-stock-count]"); if (count) count.textContent = groups.reduce((n, g) => n + g.items.length, 0);
        }
      }
      const q = $("[data-cg-stock-search]");
      if (q) q.addEventListener("input", () => {
        const v = q.value.trim().toLowerCase();
        const phone = matchMedia("(max-width: 720px)").matches;
        $$(".cg-stock li").forEach((li) => { li.hidden = !!v && !(li.textContent + " " + li.closest("details").querySelector("summary").textContent).toLowerCase().includes(v); });
        $$(".cg-stock details").forEach((d) => { const any = $$("li", d).some((li) => !li.hidden); d.hidden = !any; d.open = v ? any : !phone; });
      });
    }
  };

  const run = () => init(document);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
  document.addEventListener("shopify:section:load", (e) => init(e.target));
  // Prestige re-renders the collection section after faceting; re-bind on DOM changes inside it.
  const plp = $(".cg-plp");
  if (plp && "MutationObserver" in window) new MutationObserver(() => init(plp)).observe(plp, { childList: true, subtree: true });
})();
